import React from 'react'
import './contact.css';
import Nav from '../Nav/Nav.jsx';
import Footer from '../footer/Footer.jsx';
import { FaBuilding } from 'react-icons/fa'
import { FaLocationArrow } from 'react-icons/fa'
import { BiLogoGmail } from 'react-icons/bi'
import { FaLink } from 'react-icons/fa'
import { Link } from 'react-router-dom';
import ContactForm from './contactForm.jsx';


const Contact = () => {
  return (
    <>
      <Nav />
      <section id='aboutUs' className='banner_area '>
        <div className="banner_inner d-flex align-items-center">
          <div className="overlay"></div>
          <div className="container">
            <div className="row justify-content-center">
              <div className="col-lg-6">
                <div className="banner_content text-center">
                  <h2>Contact Us</h2>
                  <div className="page_link">
                    <Link to="/">Home</Link>
                    <a>Contact Us</a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <div className="container section_gap">
        <div className="main_title" data-aos="fade-up">
          <h2>Do you have any Query?</h2>
          <p>Replenish man have thing gathering lights yielding shall you</p>
        </div>
        <div className="row">
          <div className="col-lg-4 mb-3">
            <div className="contact_info">
              <div className="info_item">
                <FaBuilding style={{ color: "#1e2a5a" }} />
                <h6 >Chandra Reddy Towers, Hyderabad</h6>
              </div>
              <p>Ground Floor, Chandra Reddy Towers,
                100ft Road Madhapur, Hyderabad,
                Telangana, 500081</p>
              {/* <div className="info_item">
                <FaLocationArrow style={{ color: "#1e2a5a" }}/>
                  <i className="ti-headphone"></i>
                  <h6><a>+91 8088279615</a></h6>
                </div> */}
              <p>Free to call us anytime for query</p>

              <div className="info_item">
                <BiLogoGmail style={{ color: "#1e2a5a" }} />
                <i className="ti-email"></i>
                <h6><a><span className="__cf_email__" data-cfemail="c0b3b5b0b0afb2b480a3afacafb2aca9a2eea3afad">support@conquerelearning.com</span></a></h6>
              </div>
              <p>Free to mail us anytime for query</p>

              <div className="info_item">
                <FaLink style={{ color: "#1e2a5a" }} />
                <i className="ti-email"></i>
                <h6><Link to="www.ediglobe.com"><span>www.conquerelearning.com</span></Link></h6>
              </div>
              <p>For more information visit our website.</p>
              <div className="info_item">
                <FaLink style={{ color: "#1e2a5a" }} />
                <i className="ti-phone"></i>
                <h6>
                  <a href="tel:+919663928228">
                    <span>+91 9663928228</span>
                  </a>
                </h6>
              </div>
              <p>Call us anytime for queries.</p>
            </div>

          </div>
          <div className="col-lg-8">
            <ContactForm />
          </div>
        </div>
      </div>
      <Footer />
    </>
  )
}

export default Contact